import { render, staticRenderFns } from "./CenteredMessageView.vue?vue&type=template&id=796b7df5"
import script from "./CenteredMessageView.vue?vue&type=script&lang=ts"
export * from "./CenteredMessageView.vue?vue&type=script&lang=ts"
import style0 from "./CenteredMessageView.vue?vue&type=style&index=0&id=796b7df5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports